import { createActions } from "redux-actions";

const {
    sendCode,
    sendCodeSuccess,
    sendCodeFailure,
    sendCodeIdle
} = createActions(
    "SEND_CODE",
    "SEND_CODE_SUCCESS",
    "SEND_CODE_FAILURE",
    "SEND_CODE_IDLE"
);

const {
    checkCode,
    checkCodeSuccess,
    checkCodeFailure,
    checkCodeIdle
} = createActions(
    "CHECK_CODE",
    "CHECK_CODE_SUCCESS",
    "CHECK_CODE_FAILURE",
    "CHECK_CODE_IDLE"
);

export {
    sendCode,
    sendCodeSuccess,
    sendCodeFailure,
    sendCodeIdle,
    checkCode,
    checkCodeSuccess,
    checkCodeFailure,
    checkCodeIdle
};
